module.exports = "../fonts/tim.eot?5bbcde48d619caebc2190677cfcd840d";